module.exports = __webpack_public_path__ + "img/burnley-logo-icon.9bc6aa76.png";